import { AppPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import type { RegalRouteObject } from "App/routes/types";

const ReportingPage = lazyWithRetries("Reporting page", () => import("Pages/reporting/ReportingPage"));

export const reportingRoute: RegalRouteObject = {
    path: AppPagePaths.reporting,
    element: <ReportingPage />,
};
